/** Standard office fill in the floor-plan editor (stronger type color). */
const STANDARD_ZONE_EDITOR = 0x00a86b;
/** Standard office fill on the booking plan so desks and filter tints sit on top. */
const STANDARD_ZONE_BOOKING = 0x6bb896;

/**
 * Zone fill by inventory type.
 * Booking uses a muted standard green; create-plan can request the original vivid green.
 */
export function colorPerType(zoneType: number, options?: { vividStandard?: boolean }) {
  const znStandard = options?.vividStandard === true ? STANDARD_ZONE_EDITOR : STANDARD_ZONE_BOOKING;
  const znOpenSpace = 0xd8eb34;
  const znConference = 0x1798ff; // 0x2b60ab;
  const znRestricted = 0xeb5334;

  switch (zoneType) {
    case 1:
      return znStandard; // STANDARD office
    case 2:
      return znOpenSpace; // OPENSPACE
    case 3:
      return znConference; // CONFERENCE
    case 4:
      return znRestricted; // RESTRICTED
    default:
      return znStandard;
  }
}
